import React from 'react';
import cn from 'classnames';
import DropdownMenuItem from './DropdownMenuItem';
import Tooltip from './Tooltip';
import {IconProps} from '../components/icon/IconProps';


type Props = {
  caption: string
  icon: (props: IconProps) => JSX.Element
  tooltip: React.ReactNode
  id: string
  className?: string
  onClick?: () => void
  onlyChildren?: boolean
  selected?: boolean
  disabled?: boolean
}

/**
 * A dropdown menu item.
 * @param caption The caption of the item.
 * @param icon The icon of the item.
 * @param tooltip The content of tooltip for the disabled item.
 * @param id The id of the item.
 * @param className Additional classes for the item
 * @param onClick The function to call when the item is clicked.
 * @param onlyChildren If true, the caption is not rendered, only children. It allows to change the whole item.
 * @param selected True, if the item is selected.
 * @param disabled True, if the item is disabled.
 * @constructor
 */
export default function ExtendedDropdownMenuItem({
                                                   caption,
                                                   icon,
                                                   tooltip,
                                                   id,
                                                   className,
                                                   onClick,
                                                   selected = false,
                                                   disabled = false
                                                 }: Props) {
  const selectedClassName = selected ? 'font-bold' : (disabled ? 'text-gray' : '');
  return (
    <DropdownMenuItem caption={caption}
                      className={cn(className, selectedClassName)}
                      onClick={!selected && !disabled && onClick ? onClick : undefined}
                      onlyChildren={disabled}>
      <>
        {disabled &&
          <Tooltip content={tooltip} label={id}>
            {icon({
              'className': (selected ? 'text-black' : 'text-gray-dark') + " -ml-1 mr-3"
            })}
            <span className="truncate">{caption}</span>
          </Tooltip>
        }
        {!disabled &&
          icon({
            'className': (selected ? 'text-black' : 'text-gray-dark') + " -ml-1 mr-3"
          })
        }
      </>
    </DropdownMenuItem>
  )
}
